const PLAN_TYPES = new Set(['mileage', 'solo', 'entrepreneur', 'portfolio']);
const BILLING_CYCLES = new Set(['monthly', 'yearly']);

export function readPlanIntent(value) {
  const params = value instanceof URLSearchParams
    ? value
    : new URLSearchParams(typeof value === 'string' ? value : '');
  const plan = params.get('plan') || '';
  const billing = params.get('billing') || '';
  if (!PLAN_TYPES.has(plan) || !BILLING_CYCLES.has(billing)) return null;
  return {plan, billing};
}

export function buildPlanIntentSearch(intent) {
  if (!intent || !PLAN_TYPES.has(intent.plan) || !BILLING_CYCLES.has(intent.billing)) return '';
  return new URLSearchParams({plan: intent.plan, billing: intent.billing}).toString();
}

export function buildPlanIntentDestination(intent, pathname = '/onboarding') {
  const search = buildPlanIntentSearch(intent);
  return search ? `${pathname}?${search}` : pathname;
}

export function safePlanIntentDestination(value) {
  if (typeof value !== 'string' || !value.startsWith('/onboarding?') || value.startsWith('//')) return '';
  try {
    const url = new URL(value, 'https://app.silatrail.com');
    if (url.origin !== 'https://app.silatrail.com' || url.pathname !== '/onboarding') return '';
    const keys = [...url.searchParams.keys()];
    if (keys.length !== 2 || !keys.includes('plan') || !keys.includes('billing')) return '';
    const intent = readPlanIntent(url.searchParams);
    return intent ? buildPlanIntentDestination(intent) : '';
  } catch {
    return '';
  }
}
